import styled from 'styled-components'

export const StyledWethStatement = styled.div`
  font-size: 12px;
  text-align: center;
  color: ${({ theme }) => theme.colors.textBrandMuted};
  font-weight: 300;
  margin-top: 15px;
  width: 100%;

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 400;
  }
`
